<template>
	<section class="ctn">
		<section class="table">
			<heim-table :data="filteredFinancial" :columns="['id', 'name', 'delta', 'cost', 'biling']"  cols="10">
        <template slot="colgroup">
          <col class="one">
          <col class="two">
          <col class="three">
          <col class="four">
          <col class="four">
          <col>
          <col>
          <col class="ten">
        </template>
				<template slot="thead" slot-scope="props">
					<th class="collapse only-mobile"></th>
					<th class="id sortable" @click="props.sortBy('id')">#<heim-icon :icon="props.sortOrders['id'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
					<th class="sortable main" @click="props.sortBy('name')">{{ $t('servers') }}<heim-icon :icon="props.sortOrders['name'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
					<th class="server status">{{ $t('providers') }}</th>
					<th class="cost tab-noShow status">{{ $t('cost') }}</th>
					<th class="status billing tab-noShow">{{ $t('billing') }}</th>
          <th class="status billing tab-noShow"></th>
					<th class="status tab-noShow">{{ $t('delta') }}</th>
					<th class="action activity"></th>
					<th class="action details"></th>
				</template>
				<template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
					<tr :key="'sites-'+index">
						<td class="only-mobile">
							<heim-icon-button
								:class="show(item)?'opened':''"
								class="icon-button"
								@click.native="openDetail(item)">
								<heim-icon icon="chevron-right"></heim-icon>
							</heim-icon-button>
						</td>						
						<td class="id" data-title="#">{{item.id}}</td>
						<td data-title="Servers">
							<div class="row-ctn">
								<span class="label">{{item.name}}</span>
								<div class="link"><a :href="item.url" target="_blank">{{item.ip}}</a></div>
							</div>
						</td>
						<td class="provider status"><router-link :to="{ path: `/providers/${item.Providers.id}`}">{{ item.Providers.name }}</router-link></td>
						<td class="cost tab-noShow status">{{ costCostal = getCostTotal(item) }} €</td>
						<td class="billing tab-noShow status">
							<div class="popover-billing">
								<div class="b-price">{{ bilingTotal = getBilingTotal(item.Sites) }} €</div> 
							</div>
						</td>
            <td class="tab-noShow">
              	<v-popover offset="16" :disabled="!isEnabled">
									<button class="tooltip-target b3"><heim-icon icon="info-outline"></heim-icon></button>
									<template slot="popover" class="tooltip">
										<div class="pop-sites" v-for="value in item.Sites" v-bind:key="value.id">
											<div class="pop-name">{{ value.name }} :</div>
											<div class="pop-price">{{ value.hosting_cost ? $n(value.hosting_cost, "currency") : $t('noPrice') }}</div>
										</div>
										<div class="pop-no-sites" v-if="item.Sites.length === undefined || item.Sites.length == 0">
											<div class="pop-name">{{ $t("noBillingData")}}</div>
										</div>
									</template>
								</v-popover>
            </td>
						<td class="status tab-noShow" data-title="Delta">
							<span class="badge" :class="getTotal(costCostal, bilingTotal) >= 0 ? 'green' : 'red'">{{total = $n(getTotal(costCostal, bilingTotal), "currency") }}</span>
							<span class="chip" :class="getTotal(costCostal, bilingTotal) >= 0 ? 'green' : 'red'"></span>
						</td>
						<td class="activity" data-title="Activity">
							<router-link class="paper-action" :to="{ path: `/servers/${item.id}/details` }">
								<heim-icon icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon>
							</router-link>
						</td>
						<td class="details mobile-link"><router-link class="link" :to="{ path: `/servers/${item.id}/details`}"><heim-icon icon="chevron-right"></heim-icon></router-link></td>
					</tr>
					<!-- Do not add `key` here (breaks details) -->
					<!-- eslint-disable-next-line -->
					<transition name="slide-fade" :key="'detail-'+index">
						<tr v-if="show(item)" class="detail only-mobile" :data-detail="item.id">
							<td class="detail-row" :colspan="cols">
								<div class="detail-container">
									<div class="row">
										<div class="item">
											<span class="label">{{ $t('providers') }}</span>
											<div>{{ item.Providers.name }}</div>
										</div>
										<div class="item">
											<span class="label">{{ $t('cost') }}</span>
											<div>{{ $n(costCostal, "currency") }}</div>
										</div>
										<div class="item">
											<span class="label">{{ $t('billing') }}</span>
											<div>{{ $n(bilingTotal, "currency") }}</div>
										</div>
										<div class="item">
											<span class="label">{{ $t('delta') }}</span>
											<div>{{ total }}</div>
										</div>
									</div>
								</div>
							</td>
						</tr>
					</transition>
				</template>
        <template slot="tfoot" slot-scope="">
          <tr>
            <td class="label">{{ $t("totals") }}</td>
            <td></td>
            <td></td>
            <td class="status tab-noShow">{{ allCost = getAllCostTotal(servers) }} €</td>
            <td class="status tab-noShow">{{ allBiling = getBilingTotal(sites) }} €</td>
            <td class="tab-noShow"></td>
            <td class="status">
              <span class="badge tab-show" :class="getTotal(allCost, allBiling) >= 0 ? 'green' : 'red'">{{ $n(getTotal(allCost, allBiling), "currency") }}</span>
            </td>
            <td class="tab-noShow"></td>
          </tr>
        </template>
			</heim-table>
		</section>
  	</section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";
import { VTooltip, VPopover, VClosePopover } from "v-tooltip";
import Vue from "vue";

Vue.directive("tooltip", VTooltip);
Vue.directive("close-popover", VClosePopover);
Vue.component("v-popover", VPopover);

VTooltip.options.popover.defaultPlacement = "right";

export default {
  name: "FinancialList",
  components: {
    HeimIcon,
    HeimIconButton,
    HeimTable
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getServers");
    this.$store.dispatch("getSites");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.servers,
      vs => vs.sites,
      val => {
        this.setupServers();
      }
    );
    this.setupServers();
    this.setupSites();
    this.$store.dispatch("setTitle", "Financial");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ servers: state => state.serversState.servers }),
    ...mapState({ sites: state => state.sitesState.sites })
  },
  data() {
    return {
      isEnabled: true
    };
  },
  methods: {
    getCostTotal(item) {
      const costTotal =
        item.cost_server + 
        item.cost_hard_disk + 
        item.auxiliary_cost + 
        item.rds + 
        item.backup + 
        item.bandwidth + 
        item.support + 
        item.ip_elastic;
      
      return costTotal.toFixed(2);
    },
    getBilingTotal(cost) {
      const billing = [];

      cost.map(item => {
        billing.push(item.hosting_cost);
      });

      return billing.reduce((a, b) => a + b, 0).toFixed(2);
    },
    getTotal(totalCost, totalBiling) {
      const diff = totalBiling - totalCost;
      return diff.toFixed(2);
    },
    getAllCostTotal(items) {
      const cost = [];
      items.map(item => {
        cost.push(
          item.cost_server + 
          item.cost_hard_disk + 
          item.auxiliary_cost + 
          item.rds + 
          item.backup + 
          item.bandwidth + 
          item.support + 
          item.ip_elastic
        );
      });

      return cost.reduce((a, b) => a + b, 0).toFixed(2);
    }
  }
};
</script>

<style>
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: var(--heim-secondary-color);
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(var(--heim-secondary-color), 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: var(--heim-secondary-color);
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}
.pop-sites,
.pop-no-sites {
  display: flex;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  min-width: 150px;
  max-width: 400px;
  padding: 5px 0;
}

.pop-no-sites {
  text-align: center;
}

.pop-no-sites .pop-name {
  white-space: nowrap;
}

.pop-sites .pop-name {
  font-size: 15px;
  flex: 3;
  white-space: nowrap;
  margin-right: 10px;
}

.pop-sites .pop-price {
  text-align: right;
  flex: 1;
  white-space: nowrap;
}

.heim-icon i {
  cursor: pointer;
}
</style>

<style scoped>
.disabled {
  color: #8b969c;
}

.status {
  text-align: right;
}

.popover-billing {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.popover-billing div {
  flex: 1;
}

button {
  background: none;
  padding: 0;
  margin: 0;
  box-shadow: none;
  border: 0;
}

col.one { width: 8%; }
col.two { width: 10%; }
col.three { width: 15%; }
col.four { width: 20%; }
col.five { width: 1%; }
col.six { width: 1%; }
col.seven { width: 1%; }
col.eight { width: 1%; }
col.nine { width: 1%; }
col.ten { width: 1%; }

@media screen and (max-width: 1024px) {
  .tab-noShow {
    display: none;
  }
  body .tab-show {
    display: block ;
  }
}
</style>
